import React, { useRef, useState } from 'react';
import PropTypes from 'prop-types';
import ButtonSpinner from '../../../../util/ButtonSpinner';

import { checkEmail } from '../../../../redesign2019/app/utils';

const RegisterForm = (props) => {
  const {
    loading,
    authenticityToken,
    validateUsername,
    usernameValidationMessage,
    usernameValid,
    handleSubmit,
    renderValidationError,
    onChange,
    passwordsDifferentMsg,
    registerButtonDisabled,
  } = props;

  const emailInput = useRef(null);
  const [replacement, setReplacement] = useState(null);
  const [buttonCopy, setButtonCopy] = useState('Register');

  const checkEmailBeforeSubmit = (e, handleSubmit) => {
    const target = e.currentTarget;
    e.preventDefault();

    const email = emailInput.current.value;

    checkEmail(email)
      .then(() => {
        handleSubmit(target);
      })
      .catch(replacement => {
        if (buttonCopy === 'Confirm') {
          handleSubmit(target);
        } else {
          if (replacement) {
            setReplacement(replacement);
            setButtonCopy('Confirm')
          }
        }
      });
  };

  return (
    <form
      method="POST"
      action="/users"
      className="form sign-up"
      acceptCharset="UTF-8"
      onSubmit={(e) => checkEmailBeforeSubmit(e, handleSubmit)}
      id="register-form"
    >
      <input name="utf8" type="hidden" value="✓" />
      <input
        type="hidden"
        name="authenticity_token"
        value={authenticityToken}
      />

      <div className="clearfix px2">
        {props.errors.map((error) =>
          <div className="alert alert-danger" key={error}>
            <span className="error" dangerouslySetInnerHTML={{ __html: error }}></span>
          </div>
        )}

        <div className="col col-12 md-col-12 mt1 px1">
          <input
            type="text"
            className="input input-pill"
            name="user[username]"
            id="username"
            placeholder="Username"
            onChange={validateUsername(onChange)}
          />
          {
            loading &&
            <div className="username-spinner flex">
              <ButtonSpinner loading={loading} size={16} />
              &nbsp;<span>Validating username ...</span>
            </div>
          }
          {
            usernameValidationMessage &&
            <span className={usernameValid ? 'success' : 'error'}>{usernameValidationMessage}</span>
          }
          {renderValidationError('username')}
        </div>
        <div className="col col-12 md-col-12 mt1 px1">
          <input
            type="text"
            className="input input-pill"
            name="user[email]"
            id="registerEmail"
            placeholder="Email"
            is-required="true"
            is-email="true"
            onChange={onChange}
            ref={emailInput}
          />
          {
            replacement &&
            <span className="error"><em>did you mean <a style={{ cursor: "pointer" }} onClick={() => emailInput.current.value = replacement}>{replacement}</a>?</em></span>
          }
          {renderValidationError('registerEmail')}
        </div>
        <div className="col col-12 md-col-12 mt1 px1">
          <input
            type="password"
            className="input input-pill"
            name="user[password]"
            id="registerPassword"
            placeholder="Password"
            is-required="true"
            onChange={onChange}
          />
          {renderValidationError('registerPassword')}
        </div>
        <div className="col col-12 md-col-12 mt1 px1">
          <input
            type="password"
            className="input input-pill"
            name="user[password_confirmation]"
            id="passwordConfirmation"
            placeholder="Password Confirmation"
            is-required="true"
            onChange={onChange}
          />
          {renderValidationError('passwordConfirmation')}
          {passwordsDifferentMsg()}
        </div>
        <div className="col col-12 md-col-12 mt1 px1 right-align">
          <button
            type="submit"
            id="register"
            className="btn-pill btn btn-primary"
            disabled={registerButtonDisabled}
          >
            {buttonCopy || <i className="fa fa-spinner fa-pulse fa-fw" aria-hidden="true"></i>}
          </button>
        </div>
      </div>
    </form>
  );
};

RegisterForm.propTypes = {
  loading: PropTypes.bool.isRequired,
  authenticityToken: PropTypes.string.isRequired,
  validateUsername: PropTypes.func.isRequired,
  usernameValidationMessage: PropTypes.string.isRequired,
  usernameValid: PropTypes.bool.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  renderValidationError: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  passwordsDifferentMsg: PropTypes.string.isRequired,
  registerButtonDisabled: PropTypes.string.isRequired,
};

export default RegisterForm;
